import { apiClient } from '../../api/client'

// `me` is honoured by the dedicated /users/me group, which is gated on
// `organization.read` instead of `contacts.read`: managing your own
// credentials is not an act on a contact (spec 2026-09-06-04, decision 5).
// Any other uid goes through the manager-facing /users/{userUid} routes.

export const tokensApi = {
  getUserTokens: async (orgCode: string, userUid: string, type?: 'refresh_token' | 'pat' | 'email') => {
    const query = type ? { type } : undefined
    const response = userUid === 'me'
      ? await apiClient.GET('/api/v1/organizations/{orgCode}/users/me/tokens', {
          params: { path: { orgCode }, query },
        })
      : await apiClient.GET('/api/v1/organizations/{orgCode}/users/{userUid}/tokens', {
          params: { path: { orgCode, userUid }, query },
        })
    
    if (response.error) {
      throw new Error('Failed to fetch user tokens')
    }
    
    return response.data
  },
    
  createToken: async (orgCode: string, userUid: string, name: string, type: 'pat' | 'email' = 'pat', expiresIn?: number) => {
    const body = { name, type, expires_in: expiresIn || 0 }
    const response = userUid === 'me'
      ? await apiClient.POST('/api/v1/organizations/{orgCode}/users/me/tokens' as any, {
          params: { path: { orgCode } },
          body,
        })
      : await apiClient.POST('/api/v1/organizations/{orgCode}/users/{userUid}/tokens' as any, {
          params: { path: { orgCode, userUid } },
          body,
        })

    if (response.error) {
      throw new Error('Failed to create token')
    }

    return response.data as { token: string; uid: string; name: string; expires_at: string }
  },

  deletePAT: async (orgCode: string, userUid: string, tokenUid: string) => {
    const response = userUid === 'me'
      ? await apiClient.DELETE('/api/v1/organizations/{orgCode}/users/me/tokens/{tokenUid}' as any, {
          params: { path: { orgCode, tokenUid } },
        })
      : await apiClient.DELETE('/api/v1/organizations/{orgCode}/users/{userUid}/tokens/{tokenUid}' as any, {
          params: { path: { orgCode, userUid, tokenUid } },
        })

    if (response.error) {
      throw new Error('Failed to delete token')
    }

    return response.data
  },

  logoutAll: async (orgCode: string, deleteAllRefreshTokens: boolean = false) => {
    const response = await apiClient.POST('/api/v1/organizations/{orgCode}/auth/logout', {
      params: {
        path: { orgCode },
      },
      body: { deleteAllRefreshTokens },
    })

    if (response.error) {
      throw new Error('Failed to logout from all devices')
    }

    return response.data
  },

  // logoutOthers revokes every refresh-token row for the user EXCEPT the one
  // backing the current access token. The session on this device stays alive.
  logoutOthers: async (orgCode: string) => {
    const response = await apiClient.POST('/api/v1/organizations/{orgCode}/auth/logout', {
      params: {
        path: { orgCode },
      },
      body: { deleteOtherRefreshTokens: true },
    })

    if (response.error) {
      throw new Error('Failed to sign out other sessions')
    }

    return response.data
  },
}